import * as core from './core';

/**
 * handles incoming action requests for the timeclock activity.
 * @param  {Map} state current state
 * @param  {Object} action action to be executed on state
 * @return {Map} returns the new state
 */
export function signUp(state = core.initialState, { type, data }) {
  let newState;

  switch (type) {
    case 'SIGN_UP_SET_FIELD':
      newState = core.signUpSetField(state, data);
      break;
    case 'SIGN_UP_SET_PHONE':
      newState = core.signUpSetPhone(state, data);
      break;
    case 'SIGN_UP_SET_STEPS':
      newState = core.signUpSetSteps(state, data);
      break;
    case 'SIGN_UP_SET_CURRENT':
      newState = core.signUpSetCurrent(state, data);
      break;
    case 'SIGN_UP_SET_TEAM_NAME':
      newState = core.signUpSetTeamName(state, data);
      break;
    case 'SIGN_UP_SET_TEAM_VALID':
      newState = core.signUpSetTeamValid(state, data);
      break;
    case 'SIGN_UP_SET_TEAM_COLOR':
      newState = core.signUpSetTeamColour(state, data);
      break;
    case 'SIGN_UP_SET_STAFF_NAME':
      newState = core.signUpSetStaffName(state, data);
      break;
    case 'SIGN_UP_SET_STAFF_VALID':
      newState = core.signUpSetStaffValid(state, data);
      break;
    case 'SIGN_UP_SET_STAFF_TEAM':
      newState = core.signUpSetStaffTeam(state, data);
      break;
    case 'SIGN_UP_CLEAR_STATE':
      newState = core.initialState; // !new state -> return;
      break;

    case 'SIGN_UP_VALID_FORM':
      return core.signUpValidForm(state, data);
    case 'SIGN_UP_WORKING':
      return core.signUpWorking(state, data);
    case 'SIGN_UP_SET_TOAST':
      return core.signUpSetToast(state, data); // !new state -> return;
    case 'SIGN_UP_DEL_TOAST':
      return core.signUpDelToast(state); // !new state -> return;
    case 'SIGN_UP_LOAD_STATE':
      return core.signUpInit(data); // !new state -> return;
    case 'SIGN_UP_COMPLETE':
      return core.signUpComplete(state);
    default:
      return state; // !new state -> return;
  }

  return newState;
}

export default signUp;



// WEBPACK FOOTER //
// ./src/store/signUp/reducer.js